"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var restful_model_collection_1 = __importDefault(require("./restful-model-collection"));
var scheduler_1 = __importDefault(require("./scheduler"));
var scheduler_time_slot_1 = __importDefault(require("./scheduler-time-slot"));
var scheduler_booking_request_1 = require("./scheduler-booking-request");
var SchedulerRestfulModelCollection = /** @class */ (function (_super) {
    __extends(SchedulerRestfulModelCollection, _super);
    function SchedulerRestfulModelCollection(connection) {
        var _this = _super.call(this, scheduler_1.default, connection) || this;
        _this.baseUrl = 'https://api.schedule.nylas.com';
        _this.connection = connection;
        _this.modelClass = scheduler_1.default;
        return _this;
    }
    SchedulerRestfulModelCollection.prototype.getGoogleAvailability = function () {
        return this.connection.request({
            method: 'GET',
            path: '/schedule/availability/google',
            headers: {
                'Content-Type': 'application/json',
            },
            baseUrl: this.baseUrl,
        });
    };
    SchedulerRestfulModelCollection.prototype.getOffice365Availability = function () {
        return this.connection.request({
            method: 'GET',
            path: '/schedule/availability/o365',
            headers: {
                'Content-Type': 'application/json',
            },
            baseUrl: this.baseUrl,
        });
    };
    SchedulerRestfulModelCollection.prototype.getPageBySlug = function (slug) {
        var _this = this;
        return this.connection
            .request({
            method: 'GET',
            path: "/schedule/" + slug + "/info",
            headers: {
                'Content-Type': 'application/json',
            },
            baseUrl: this.baseUrl,
        })
            .then(function (json) {
            return Promise.resolve(new scheduler_1.default(_this.connection).fromJSON(json));
        });
    };
    SchedulerRestfulModelCollection.prototype.getAvailableTimeSlots = function (slug) {
        return this.connection
            .request({
            method: 'GET',
            path: "/schedule/" + slug + "/timeslots",
            headers: {
                'Content-Type': 'application/json',
            },
            baseUrl: this.baseUrl,
        })
            .then(function (json) {
            var timeslots = json.map(function (timeslot) {
                return new scheduler_time_slot_1.default().fromJSON(timeslot);
            });
            return Promise.resolve(timeslots);
        });
    };
    SchedulerRestfulModelCollection.prototype.bookTimeSlot = function (slug, bookingRequest) {
        return this.connection
            .request({
            method: 'POST',
            path: "/schedule/" + slug + "/timeslots",
            headers: {
                'Content-Type': 'application/json',
            },
            body: bookingRequest.toJSON(),
            baseUrl: this.baseUrl,
        })
            .then(function (json) {
            return Promise.resolve(new scheduler_booking_request_1.SchedulerBookingConfirmation().fromJSON(json));
        });
    };
    SchedulerRestfulModelCollection.prototype.cancelBooking = function (slug, editHash, reason) {
        return this.connection
            .request({
            method: 'POST',
            path: "/schedule/" + slug + "/" + editHash + "/cancel",
            headers: {
                'Content-Type': 'application/json',
            },
            body: {
                reason: reason,
            },
            baseUrl: this.baseUrl,
        })
            .then(function (json) {
            return Promise.resolve(json);
        });
    };
    SchedulerRestfulModelCollection.prototype.confirmBooking = function (slug, editHash) {
        return this.connection
            .request({
            method: 'POST',
            path: "/schedule/" + slug + "/" + editHash + "/confirm",
            headers: {
                'Content-Type': 'application/json',
            },
            body: {},
            baseUrl: this.baseUrl,
        })
            .then(function (json) {
            return Promise.resolve(new scheduler_booking_request_1.SchedulerBookingConfirmation().fromJSON(json));
        });
    };
    return SchedulerRestfulModelCollection;
}(restful_model_collection_1.default));
exports.default = SchedulerRestfulModelCollection;
